const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { containerized, margin } = attributes;

  return (
    <section className={`${margin}`}>
      <div className={`${containerized ? 'Container' : ''}`}>
        <InnerBlocks.Content />
      </div>
    </section>
  );
};
